import actions from 'netxcore@netx/core-app/actions';
import {extendBackboneActions} from '@netx/core/utils/extendBackboneActions';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {faPowerOff} from '@fortawesome/pro-solid-svg-icons';
const iconOpts = {classes: ['fa-fw']};
const icons = {
	faPowerOff: icon(faPowerOff, iconOpts).html,
};

// Extend actions defined in core file
let newActions = extendBackboneActions(actions, [
	/**
	 * @action
	 * @override
	 */
	{
		event: 'app:logout',
		icon: icons.faPowerOff,
		route: '#logout',
	},
]);

export default newActions;
